import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {
    setMNStatisticGroup:(state, data) => {
        state.mnStatisticGroup = data
    },
    setMNStatisticDetail:(state, data) => {
        state.mnStatisticDetail = data
    },
    pushMNStatisticDetail:(state, data) => {
        state.mnStatisticDetail = state.mnStatisticDetail.concat(data)
    },
};
